import CreanceVueProduits from '@/components/comptable/creance/creance-vue-produits'
import CreanceVuePatients from '@/components/caisse/factures/creance-patients'
import CreanceFactures from '@/components/comptable/creance/creance-factures'
import CreanceForfaitaires from '@/components/comptable/creance/creance-forfaitaire'
import CreanceConsoReelles from '@/components/comptable/creance/creance-conso-reelles'
import Prestation from "@/components/comptable/prestations-exploitations/prestation"
import PrintFactureAssurance from '@/components/comptable/creance/print-facture-assurance'
import store_operation from '@/store/mods/caisse/operations'

export default {
    name: 'creance',
    components: {
        CreanceVueProduits, CreanceVuePatients, CreanceFactures, Prestation,
        CreanceForfaitaires, PrintFactureAssurance, CreanceConsoReelles
    },
    props: [],
    data() {
        return {
            config_to_show: 'vue-produits',

            is_recap: true,
            montant_en_lettre: '',
            montant_total: 0,
            can_print: false,
            is_month: false,
            liste_produits_creances: [],
            current_date_filter: {},
            curr_month: "",

            is_assurance_bill: false,
            selected_facture: {},
            view_by_societe: [],
            view_patients: [],
            total_facture: 0,
            total_en_lettre: '',
            selected_view: '',
            devise_mode: 'principale',
            print_toggler: 0,
            type_facture: '',
            lettres_creances: [],
            lettres_loading: false,
            lettres_error: false,
            lettres_debiteur_selectionne: null,
            lettre_selectionnee: null,
            imprimer_lettre: false,
            rappels_recouvrement: [],
            rappels_loading: false,
            rappels_error: false,
            rappels_recherche: '',
            rappel_en_cours: null,
            rappel_timer: null
        }
    },

    computed: {
        lettres_filtrees() {
            const selection = this.lettres_debiteur_selectionne
            return selection ? this.lettres_creances.filter(item => this.cleDebiteur(item) === selection.cle) : this.lettres_creances
        },
        lettres_options() {
            return this.lettres_creances.map(item => ({
                cle: this.cleDebiteur(item),
                libelle: item.nom
            })).sort((a, b) => a.libelle.localeCompare(b.libelle, 'fr', { sensitivity: 'base' }))
        },
        total_lettres_du() {
            return this.lettres_creances.reduce((total, item) => total + Number(item.reste || 0), 0)
        },
        taux_lettres_usd() {
            const taux = Number(this.currency_info && this.currency_info.rate)
            return String(this.currency_info && this.currency_info.secondary_currency).toUpperCase() === 'USD' && taux > 0
                ? taux : null
        },
        rappels_actifs() {
            return this.rappels_recouvrement.filter(item => item.rappel_actif).length
        },
        rappels_filtres() {
            const recherche = this.rappels_recherche.trim().toLocaleLowerCase('fr')
            return recherche ? this.rappels_recouvrement.filter(item =>
                [item.facture_reference, item.facture_assurance, item.facture_societe, item.personne_contactee, item.action_attendue]
                    .some(value => String(value || '').toLocaleLowerCase('fr').includes(recherche))) : this.rappels_recouvrement
        }
    },

    mounted() {
        // Lien direct vers un onglet (ex. tableau Finances → /creance?onglet=vue-assurance&vue=remboursement)
        const onglet = this.$route && this.$route.query.onglet
        if (onglet) this.changeTab(onglet)
        this.chargerRappelsRecouvrement()
        this.rappel_timer = window.setInterval(() => this.chargerRappelsRecouvrement(), 60000)
    },

    beforeDestroy() {
        if (this.rappel_timer) window.clearInterval(this.rappel_timer)
    },

    methods: {
        cleDebiteur(debiteur) {
            return `${debiteur.type}:${debiteur.id || debiteur.nom}:${debiteur.nom}`
        },
        changeTab(tab_to_show) {
            this.config_to_show = tab_to_show
            if (tab_to_show === 'lettres-creances') this.chargerLettresCreances()
            if (tab_to_show === 'suivi-recouvrement') this.chargerRappelsRecouvrement()
        },

        async chargerRappelsRecouvrement() {
            this.rappels_loading = true
            this.rappels_error = false
            try {
                const response = await store_operation.getRappelsRecouvrement(this.getClinicTimezone())
                this.rappels_recouvrement = response.data || []
            } catch (_) {
                this.rappels_error = true
            } finally {
                this.rappels_loading = false
            }
        },

        async terminerRappelRecouvrement(id) {
            this.rappel_en_cours = id
            try {
                await store_operation.terminerSuiviRecouvrement(id)
                await this.chargerRappelsRecouvrement()
            } catch (_) {
                this.rappels_error = true
            } finally {
                this.rappel_en_cours = null
            }
        },

        chargerLettresCreances() {
            this.lettres_loading = true
            this.lettres_error = false
            store_operation.getLettresCreances().then(response => {
                if (!response.success) throw new Error('Réponse invalide')
                this.lettres_creances = response.data || []
                if (this.lettres_debiteur_selectionne && !this.lettres_creances.some(item =>
                    this.cleDebiteur(item) === this.lettres_debiteur_selectionne.cle)) {
                    this.lettres_debiteur_selectionne = null
                }
            }).catch(() => {
                this.lettres_error = true
            }).finally(() => {
                this.lettres_loading = false
            })
        },

        libelleMois(periode) {
            const [annee, mois] = periode.split('-').map(Number)
            return new Intl.DateTimeFormat('fr', { month: 'long', year: 'numeric' })
                .format(new Date(annee, mois - 1, 1))
        },

        formatUsd(value) {
            return new Intl.NumberFormat('fr-FR', { maximumFractionDigits: 2 }).format(Number(value || 0))
        },

        formatDateVersement(versement) {
            if (!versement.date) return 'Non renseignée'
            if (versement.date_utc) {
                const iso = String(versement.date).replace(' ', 'T')
                const date = new Date(/[zZ]|[+-]\d\d:\d\d$/.test(iso) ? iso : iso + 'Z')
                return this.formatDateToDateHour(date)
            }
            const match = String(versement.date).match(/^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{2}):(\d{2}))?/)
            return match ? `${match[3]}/${match[2]}/${match[1]}${match[4] ? ` à ${match[4]}h${match[5]}` : ''}` : 'Non renseignée'
        },

        libelleModePaiement(mode) {
            return ({ cheque: 'Chèque', virement: 'Virement', especes: 'Espèces', mobile_money: 'Mobile Money', autre: 'Autre' })[mode] || 'Non renseigné'
        },

        imprimerLettreCreance(debiteur) {
            this.lettre_selectionnee = debiteur
            this.imprimer_lettre = true
            this.$nextTick(() => {
                window.addEventListener('afterprint', () => { this.imprimer_lettre = false }, { once: true })
                window.print()
            })
        },

        printCreances(print_data) {
            this.is_recap = print_data.is_recap
            this.can_print = true
            this.liste_produits_creances = print_data.liste_produits_creances
            this.montant_total = print_data.montant_total
            this.montant_en_lettre = print_data.montant_en_lettre
            this.current_date_filter = print_data.current_date_filter
            this.is_month = print_data.is_month
            this.curr_month = print_data.curr_month

            setTimeout(() => {
                window.print()
                this.can_print = false
            }, 500);
        },

        setPrintFactureAssurance(invoice_data) {
            this.print_toggler = (this.print_toggler == 0)?1:0
            this.is_assurance_bill = invoice_data.is_assurance_bill
            this.selected_facture = invoice_data.selected_facture
            this.view_by_societe = invoice_data.view_by_societe
            this.view_patients = invoice_data.view_patients
            this.total_facture = invoice_data.total_facture
            this.total_en_lettre = invoice_data.total_en_lettre
            this.selected_view = invoice_data.selected_view
            this.devise_mode = invoice_data.devise_mode || 'principale'
            this.type_facture = 'facture_assurance'
        },

        setPrintFactureSociete(invoice_data) {
            console.log(">> to print 3",invoice_data);
            this.print_toggler = (this.print_toggler == 0)?1:0
            this.selected_facture = invoice_data.selected_facture
            this.total_facture = invoice_data.total_facture
            this.total_en_lettre = invoice_data.total_en_lettre
            this.type_facture = 'facture_forfaitaire'
        }
    }
}
